
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        
        anime({
            targets: "#l-bg__line-animation",
            rotate:"360deg",
            easing:"linear",
            duration:20000,
            loop:true,
        })
        
    }
}